import React from 'react';

import Block from './Block';
import SupportContact from '../../partials/SupportContact';

export default function Hebergements() {
  return (
    <>
      <div className="content large">
        <div className="fullwidth">
          <p>Les hôtels ci-dessous, proches d'Exponantes vous proposent des avantages
             tarifaires sur<br/>
           présentation du code&nbsp;: <b>BTLec Ouest 2026</b></p>
        </div>
        <div className="col">
          <Block
            title = "Sure Hotel by Best Western Nantes Beaujoire"
          >
            <p>À 2,6 km du parc des expositions de la Beaujoire.<br/>
            27 rue du Chemin Rouge, 44300 Nantes</p>
            <p><b>105€</b> B&B au lieu de 132€ (-20%)</p>
            <p>Tarif préférentiel Soirée Étape avec le menu 2 plats compris à 130€ pour une chambre single</p>
            <p className="web">Site web : <a href='https://www.nantesbeaujoire.com/' target="_blank">https://www.nantesbeaujoire.com/</a></p>
            <p>Google Maps : <a href='https://maps.app.goo.gl/184AeVaSgQfq7pK1A' target="_blank">https://maps.app.goo.gl/184AeVaSgQfq7pK1A</a></p>
            <p className="tel">Téléphone: <a href="tel:02 14 00 07 89">02 14 00 07 89</a></p>
          </Block>
        </div>
        <div className="col">
          <Block
            title = "Comfort Aparthotel Nantes La Beaujoire"
          >
            <p>
              <b>-15%</b> en indiquant  le code réservation " BTLec Ouest 2026 " lors de la réservation en ligne sur le site internet
            </p>
            <p className="web">Site web : <a href='https://www.zenitude-hotel-residences.com/residences/nantes-la-beaujoire/' target="_blank">https://www.zenitude-hotel-residences.com/residences/nantes-la-beaujoire/</a></p>
            <p>Google Maps : <a href='https://maps.app.goo.gl/yEW4bQfxPEGbS92RA' target="_blank">https://maps.app.goo.gl/yEW4bQfxPEGbS92RA</a></p>
          </Block>
          <Block
            title = "L'hôtel Brit Hôtel"
          >
            <p>1km du parc des Expositions de la Beaujoire<br/>
            45 Boulevard des Batignolles, 44300 Nantes</p>
            <p><b>-14%</b> sur la chambre single avec petit-déjeuner en indiquant le code réservation " BTLec Ouest 2026 " lors de la réservation en ligne sur le site internet.</p>
            <p className="web">Site web : <a href='https://hotel-nantes-beaujoire.brithotel.fr/' target="_blank">https://hotel-nantes-beaujoire.brithotel.fr/</a></p>
            <p>Google Maps : <a href='https://maps.app.goo.gl/iiV8TQPhprKjsw7J8' target="_blank">https://maps.app.goo.gl/iiV8TQPhprKjsw7J8</a></p>
            <p className="tel">Téléphone: <a href="tel:02 40 50 07 07">02 40 50 07 07</a></p>
          </Block>
        </div>
        <div className="col">
          <Block
            title = "Zenitude Hôtel-Résidences Nantes Métropole"
          >
            <p>À 2,6 km du parc des expositions de la Beaujoire.<br/>
            2 rue des Citrines 44300 Nantes</p>
            <p><b>-15%</b>  en indiquant le code réservation "BTLec Ouest 2026 " lors de la réservation en ligne sur le site internet</p>
            <p className="web">Site web : <a href='https://www.zenitude-hotel-residences.com/residences/nantes-metropole/' target="_blank">https://www.zenitude-hotel-residences.com/residences/nantes-metropole/</a></p>
            <p>Google Maps : <a href='https://maps.app.goo.gl/CdWbVR68oYXPKf2o7' target="_blank">https://maps.app.goo.gl/CdWbVR68oYXPKf2o7</a></p>
            <p className="tel">Téléphone: <a href="tel:02 28 08 80 00">02 28 08 80 00</a></p>
          </Block>
        </div>
      </div>
      <div className="support content large">
        <SupportContact breakingPoint={900}/>
      </div>
    </>
  );
}
